import * as Sentry from '@sentry/browser';
import * as SelfiesService from 'Services/SelfiesService';

export const SET_SELFIE_REQUEST = 'SET_SELFIE_REQUEST';
export const REMOVE_SELFIE_REQUEST = 'REMOVE_SELFIE_REQUEST';

export const setSelfie = (file, filename) => ({
  type: SET_SELFIE_REQUEST,
  file,
  filename,
});

export const removeSelfie = filename => ({
  type: REMOVE_SELFIE_REQUEST,
  filename,
});

// ----------------------------------------------------------------------------

export const SAVE_SELFIES_REQUEST = 'SAVE_SELFIES_REQUEST';
export const SAVE_SELFIES_SUCCESS = 'SAVE_SELFIES_SUCCESS';
export const SAVE_SELFIES_FAILURE = 'SAVE_SELFIES_FAILURE';

export const CLEAR_SELFIES_ERROR = 'CLEAR_SELFIES_ERROR';

const requestSaveSelfie = () => {
  return { type: SAVE_SELFIES_REQUEST };
};

const receiveSaveSelfie = () => {
  return { type: SAVE_SELFIES_SUCCESS };
};

const receiveSaveSelfieError = error => {
  return { type: SAVE_SELFIES_FAILURE, error };
};

export const saveSelfies = files => async dispatch => {
  dispatch(requestSaveSelfie());
  try {
    await SelfiesService.upload(files);
    dispatch(receiveSaveSelfie());
  } catch (err) {
    dispatch(receiveSaveSelfieError(err));
    Sentry.captureMessage('API action (Selfies.saveSelfies)');
  }
};

export const clearSefliesError = () => {
  return { type: CLEAR_SELFIES_ERROR };
};
